import firebase from 'firebase/app'
const db = firebase.firestore()

const state = {
  students: [],
  libraries: [],
  library: [],
  variants: [],
  webinars: [],
  webinar: []
}

const actions = {
  GET_STUDENTS ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('students')
      let unsub = ref.onSnapshot(snapshot => {
        let students = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          students.push(log)
        })
        commit('SET_LOADED_STUDENTS', students)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  GET_LIBRARIES ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('libraries')
      let unsub = ref.onSnapshot(snapshot => {
        let libraries = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          libraries.push(log)
        })
        commit('SET_LOADED_LIBRARIES', libraries)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  CREATE_LIBRARY ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.library
      db.collection('libraries')
        .doc(String(data['slug']))
        .set(data)
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  UPDATE_LIBRARY ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload
      db.collection('libraries')
        .doc(data.slug)
        .update({
          title: data.title,
          createdAt: data.createdAt,
          slug: data.slug,
          isActive: data.isActive,
          isFree: data.isFree,
          isExam: data.isExam,
          description: data.description,
          shortDescription: data.shortDescription
        })
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  GET_LIBRARY ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let libraries = []
      db.collection('libraries')
        .doc(slug)
        .get()
        .then((doc) => {
          if (doc) {
            libraries.push(doc.data())
            commit('SET_LOADED_LIBRARY', libraries[0])
            resolve(doc)
          }
        })
    })
  },
  CREATE_LIBRARY_VARIANT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('libraries')
        .doc(payload.librarySlug)
        .collection('variants')
        .doc(String(payload.variant.slug))
        .set(payload.variant)
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  UPDATE_LIBRARY_VARIANT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.variant
      db.collection('libraries')
        .doc(payload.librarySlug)
        .collection('variants')
        .doc(String(payload.variant.slug))
        .update({
          title: data.title,
          createdAt: data.createdAt,
          slug: data.slug,
          isActive: data.isActive,
          description: data.description,
          questions: data.questions
        })
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  ADD_LIBRARY_VARIANT_QUESTION ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('library')
        .doc(payload.librarySlug)
        .collection('variants')
        .doc(String(payload.variant.slug))
        .update({
          questions: firebase.firestore.FieldValue.arrayUnion(payload.question)
        })
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  GET_LIBRARY_VARIANTS ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('libraries').doc(slug).collection('variants')
      let unsub = ref.onSnapshot(snapshot => {
        let variants = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          variants.push(log)
        })
        commit('SET_LOADED_VARIANTS', variants)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  CREATE_LIBRARY_CLASS ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('libraries')
        .doc(payload.librarySlug)
        .collection('classes')
        .doc(String(payload.libraryClass.slug))
        .set(payload.libraryClass)
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  UPDATE_LIBRARY_CLASS ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.libraryClass
      db.collection('libraries')
        .doc(payload.librarySlug)
        .collection('classes')
        .doc(String(payload.libraryClass.slug))
        .update({
          title: data.title,
          createdAt: data.createdAt,
          slug: data.slug,
          isActive: data.isActive,
          weeks: data.weeks
        })
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  GET_LIBRARY_CLASSES ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('libraries').doc(slug).collection('classes')
      let unsub = ref.onSnapshot(snapshot => {
        let libraryClasses = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          libraryClasses.push(log)
        })
        commit('SET_LOADED_CLASSES', libraryClasses)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  ADD_LIBRARY_CLASS_WEEK ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('libraries')
        .doc(payload.librarySlug)
        .collection('classes')
        .doc(String(payload.libraryClass.slug))
        .update({
          weeks: firebase.firestore.FieldValue.arrayUnion(payload.libraryClassWeek)
        })
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  UPDATE_LIBRARY_CLASS_WEEK ({ commit }, payload) {
    console.log(payload)
    // return new Promise((resolve, reject) => {
    //   db.collection('libraries')
    //     .doc(payload.librarySlug)
    //     .collection('classes')
    //     .doc(String(payload.libraryClass.slug))
    //     .set({
    //       weeks: {
    //         [payload.libraryClassWeek.slug - 1]: firebase.firestore.FieldValue.arrayUnion(payload.libraryClassWeek)
    //       }
    //     }, { merge: true })
    //     .then(snapshot => {
    //       resolve(snapshot)
    //     })
    // })
  },
  GET_WEBINAR ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let webinars = []
      db.collection('webinars')
        .doc(slug)
        .get()
        .then((doc) => {
          if (doc) {
            webinars.push(doc.data())
            commit('SET_LOADED_WEBINAR', webinars[0])
          }
        })
    })
  },
  GET_WEBINARS ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('webinars')
      let unsub = ref.onSnapshot(snapshot => {
        let webinars = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          webinars.push(log)
        })
        commit('SET_LOADED_WEBINARS', webinars)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  CREATE_WEBINAR ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.webinar
      db.collection('webinars')
        .doc(String(data['slug']))
        .set(data)
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  },
  UPDATE_WEBINAR ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload
      db.collection('webinars')
        .doc(data.slug)
        .update({
          title: data.title,
          createdAt: data.createdAt,
          slug: data.slug,
          isActive: data.isActive,
          description: data.description,
          date: data.date,
          picture: data.picture
        })
        .then(snapshot => {
          resolve(snapshot)
        })
    })
  }
}

const getters = {
}

const mutations = {
  SET_LOADED_STUDENTS (state, payload) {
    state.students = payload
  },
  SET_LOADED_LIBRARIES (state, payload) {
    state.libraries = payload
  },
  SET_LOADED_LIBRARY (state, payload) {
    state.library = payload
  },
  SET_LOADED_VARIANTS (state, payload) {
    state.variants = payload
  },
  SET_LOADED_WEBINAR (state, payload) {
    state.webinar = payload
  },
  SET_LOADED_WEBINARS (state, payload) {
    state.webinars = payload
  },
  SET_LOADED_CLASSES (state, payload) {
    state.libraryClasses = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
